<template>
  <v-tooltip
    v-if="!isDesktop || isExtensionPopup"
    :open-on-hover="true"
    location="top" :open-delay="300"
    content-class="text-neutral0 bg-neutral900"
    :disabled="isMobile"
  >
    <span>{{ t('cta.filter') }}</span>
    <template #activator="{ props }">
      <BrandButton
        variant="secondary"
        color="text-neutral900 bg-neutral25"
        v-bind="{ ...props, ...toolbarBtnProps, ...$attrs }"
        flat
      >
        <PhFadersHorizontal class="text-h5" />
        <span v-if="!isCompact" class="ml-3" v-text="t('cta.filter')" />
      </BrandButton>
    </template>
  </v-tooltip>
</template>

<script setup>
import { computed, defineOptions } from 'vue'
import { useStore } from 'vuex'
import { useI18n } from 'vue-i18n'
import { useDisplay } from 'vuetify'
import { PhFadersHorizontal } from '@phosphor-icons/vue'
import { useToolbarButtonStyle } from '@/composables/useToolbarButtonStyle'

defineOptions({ inheritAttrs: false })

const store = useStore()
const { t } = useI18n()
const display = useDisplay()
const isMobile = computed(() => display.smAndDown.value)
const { isCompact, toolbarBtnProps } = useToolbarButtonStyle()

const isExtensionPopup = computed(() => store.getters['device/isExtensionPopup'])
const isDesktop = computed(() => store.getters['device/isDesktop'])
</script>
